
import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import { useReactToPrint } from "react-to-print";
import { Search } from 'lucide-react';
import classes from "./PrintBank.module.css"
import plus from "../../../Assets/plus.svg"
import run from "../../../Assets/run.svg"
import MailLogo from "../../../Assets/mail.svg"
import PrintLogo from "../../../Assets/print.svg"
import DownloadLogo from "../../../Assets/down.svg"
import BackLogo from "../../../Assets/back.svg"
import RotatingLogo from '../../../Assets/rotating-logo.png'
import EyeIcon from "../../../Assets/new-eye.svg"
import DeleteIcon from "../../../Assets/new-delete.svg"
import PencilIcon from "../../../Assets/pencil.svg"
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { RiDeleteBinLine } from "react-icons/ri";
import { Spinner, Badge, Button, Modal, Form } from 'react-bootstrap';
import CurrencyInput from 'react-currency-input-field';
import HeaderNav from "../../Accoungting/HeaderNav/HeaderNav";
import axios from "axios";
import { BASE_URL } from "../../../Components/Styles/API/API";
import { useLocation, useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import download from "../../../Assets/download1.svg"
import upload from "../../../Assets/upload.svg"
import logo from "../../../Assets/rotating-logo.png";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Multiselect from "../../../Components/Multiselect";
import Swal from 'sweetalert2';









const BankSummary = () => {
  const location = useLocation();
const [noData, setNoData] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectOptions, setSelectOptions] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [load, setLoad] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [tableData3, setTableData3] = useState([]);
  const [tableData4, setTableData4] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [selectedProvince, setSelectedProvince] = useState('');
  const [selectedRegion, setSelectedRegion] = useState('');
  const [selectedContinent, setSelectedContinent] = useState('');
  const [tableData45, setTableData45] = useState([]);
  const [totalDebit, setTotalDebit] = useState('');
  const [totalCredit, setTotalCredit] = useState('');
  const [allAccounts, setAllAccounts] = useState([]);
  const [fetchingLoading, setFetchingLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedBank, setSelectedBank] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [searchedResult, setSearchedResult] = useState([]);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [bearer, setBearer] = useState('');
  const [user, setUser] = useState('');
  const [error, setError] = useState(null);
  const [entriesPerPage, setEntriesPerPage] = useState(100);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalEntries, setTotalEntries] = useState("");
  const [loanCode, setLoanCode] = useState("");
  const [loanDescription, setLoanDescription] = useState("");
  const [selectedReportTo, setSelectedReportTo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [savingsLoading, setSavingsLoading] = useState(false);
  const [show1, setShow1] = useState(false);
  const [cashbook, setCashbook] = useState([]);
  const [tableData, setTableData] = useState([]);
   const [selectedIds, setSelectedIds] = useState([]);
  const navigate = useNavigate();
  const [benLoading, setBenLoading] = useState(false);
  const [statLoading, setStatLoading] = useState(false);
  const [stat, setStat] = useState([]);
  const [currentMonth, setCurrentMonth] = useState("");
  const [minDate, setMinDate] = useState("");
  const [maxDate, setMaxDate] = useState("");
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedEndDate, setSelectedEndDate] = useState('');
  const [inputss, setInputss] = useState([]);
  const [loadings, setLoadings] = useState(false);
  const [continent, setContinent] = useState('');
  const [region, setRegion] = useState('');
  const [province, setProvince] = useState('');
  const [admin, setAdmin] = useState('');
  const [usert, setUsert] = useState("");
  

  const readData = async () => {
    try {
      const value = await localStorage.getItem('userToken');
      const value1 = await localStorage.getItem('tobi');
      const current = await localStorage.getItem('currentMonth');
      const admins = await localStorage.getItem('admin');
      // const saved = localStorage.getItem("cashbook_preview");
      const continentName = await localStorage.getItem('continent');
      const regionName = await localStorage.getItem('region');
      const provinceName = await localStorage.getItem('province');
      const usertype = await localStorage.getItem('userType');
      const provinceid = await localStorage.getItem('provinceID');
      const continentid = await localStorage.getItem('continentID');
      const regionid = await localStorage.getItem('regionID');

      if (value !== null) {
        setBearer(value);
      }
      // if (saved) {
      //   setCashbook(JSON.parse(saved));
      // }

      if (value1 !== null) {
        setUser(value1);
      }
      if (provinceid !== null) {
        setSelectedProvince(provinceid);
      }
      if (continentid !== null) {
        setSelectedContinent(continentid);
      }
      if (regionid !== null) {
        setSelectedRegion(regionid);
      }

      if (usertype !== null) {
        setUsert(usertype);
      }
      if (current !== null) {
        console.log(current);
        const date = new Date(current);

        setCurrentMonth(date);

        const startOfDateRange = new Date(1900, 0, 1);

        const endOfDateRange = new Date(date.getFullYear(), date.getMonth() + 1, 0);

        // Format date function as 'YYYY-MM-DD'
        const formatDate = (date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        };

        setMinDate(formatDate(startOfDateRange));
        setMaxDate(formatDate(endOfDateRange));

        console.log("Date Range:", formatDate(startOfDateRange), "to", formatDate(endOfDateRange));
      }
      if (admins !== null) {
        setAdmin(admins);
      }
      if (continentName !== null) {
        setContinent(continentName);
      }
      if (regionName !== null) {
        setRegion(regionName);
      }
      if (provinceName !== null) {
        setProvince(provinceName);
      }
    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };


const handleChange = (selected) => {
    // Check if "Select All" was clicked
    if (selected?.some((opt) => opt.value === "ALL")) {
      if (selectedOptions.length === allAccounts.length) {
        // If all are already selected -> unselect all
        setSelectedOptions([]);
        handleBank([]); // pass empty back
      } else {
        // Otherwise select everything
        setSelectedOptions(allAccounts);
        handleBank(allAccounts);
      }
    } else {
      setSelectedOptions(selected || []);
      handleBank(selected || []);
    }
  };

  // prepend "Select All" option
  const optionsWithAll = [{ value: "ALL", label: "Select All" }, ...allAccounts];





  const handleShow1 = (loan) => {
    setLoanCode(loan.code);
    setLoanDescription(loan.description);
    setSelectedReportTo(loan.reportTo);
    setShow1(true);
  };

  const handleClose1 = () => setShow1(false);


  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  const handleCustomers = async () => {
    setBenLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/fetch-pending-sales-invoice-paginated?page=${currentPage}`, { headers });
      const results = response.data?.data?.data;
      const resultx = response.data?.data?.total;
      setTotalEntries(resultx);
      setTableData(results);
      console.log(results, "From Remittane")
      const total = response.data?.data?.last_page || 1;
      setTotalPages(total);

    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response?.data && error.response?.data.message) {
          if (typeof error.response?.data.message === 'string') {
            errorMessage = error.response?.data.message;
          } else if (Array.isArray(error.response?.data.message)) {
            errorMessage = error.response?.data.message.join('; ');
          } else if (typeof error.response?.data.message === 'object') {
            console.log(errorMessage);
            setError(errorMessage)
          }
        }
        setTableData([]);
      }
    } finally {
      setBenLoading(false);
    }

  };

  useEffect(() => {
    if (bearer) {
      handleCustomers();
    }
  }, [bearer, currentPage]);

 const fetchReports = async () => {
  setSavingsLoading(true);
  try {
    // const selectedRowIds = selectedIds.map(row => row.id);
    const response = await axios.get(`${BASE_URL}/reports/date-bank-summary-report`, {
      params: {
       category_id: selectedIds,
          start_date: selectedDate,
          end_date: selectedEndDate,
          continent_id: usert == '2' ? selectedContinent : "",
          region_id: usert == '3' ? selectedRegion : "",
          province_id: usert == '4' ? selectedProvince : ""
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${bearer}`
      }
    });

    // if (!response.data?.data?.journal || response.data?.data?.journal.length === 0) {
    //   setAccounts([]);   // ✅ clear previous data
    //   setNoData(true);
    //   return;
    // }

    // const resultsss = response.data?.data?.journal;
    // const resultssx = response.data?.data?.input;

    // setAccounts(resultsss);
    // setInputss(resultssx);
    // setNoData(false);

    const filtData1 = response.data?.data?.records || [];
    const filtData2 = response.data?.data || [];

    if (filtData1.length === 0) {
      Swal.fire({
        icon: 'error',
        title: 'No Data Found',
        text: 'No data found for the selected account.',
      });
      
    } else {
      // setInputss(filtData1);
      setAccounts(filtData1);
      setInputss(filtData2);
      // navigate('/accounting/print_bank_consolidated', { state: { accounts: filtData1, selectedDate, selectedEndDate, inputs: filtData2 } });

    }
    console.log(response, "consolidated");
    
    console.log(filtData1);

  } catch (error) {
    if (error.response && error.response.status === 401) {
      navigate('/login');
    } else {
      console.log(error);
      setAccounts([]);   // ✅ also clear here on error
      setNoData(true);
    }
  } finally {
    setSavingsLoading(false);
  }
};


 useEffect(() => {
    if (accounts) {
      const creditTotal = accounts
        .filter((item) => !isNaN(item.nCredit) && item.nCredit !== '')
        .reduce((total, item) => total + parseFloat(item.nCredit), 0);

      const debitTotal = accounts
        .filter((item) => !isNaN(item.nDebit) && item.nDebit !== '')
        .reduce((total, item) => total + parseFloat(item.nDebit), 0);

      // Format the numbers with commas and two decimal places
      const formattedDebitTotal = debitTotal.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

      const formattedCreditTotal = creditTotal.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

      setTotalDebit(formattedDebitTotal);
      setTotalCredit(formattedCreditTotal);
    }
  }, [accounts]);

  const groupedData = accounts.reduce((acc, item) => {
    if (!acc[item.gl_code]) {
      acc[item.gl_code] = [];
    }
    acc[item.gl_code].push(item);
    return acc;
  }, {});

  const getFiscalMonth = (transactionDate) => {
  const date = new Date(transactionDate);
  const calendarMonth = date.getMonth(); // 0-11
  // Fiscal month: Sep = 0, Oct = 1, ..., Aug = 11
  const fiscalMonth = (calendarMonth + 4) % 12 + 1; // Shift so Sep=1, Aug=12
  return fiscalMonth.toString().padStart(2, '0');
};


const calculateTotals = (group) => {
  return group.reduce(
    (totals, item) => {
      totals.debit += parseFloat(item.debit) || 0;
      totals.credit += parseFloat(item.credit) || 0;
      return totals;
    },
    { debit: 0, credit: 0 }
  );
};


  const filteredAccounts = accounts.filter((item) => {
    const term = searchTerm.toLowerCase();
    return (
      item.details?.toLowerCase().includes(term) ||
      item.cheque_number?.toLowerCase().includes(term) ||
      item.transaction_date?.toLowerCase().includes(term)
    );
  });


  const fetchAccountss = async () => {
    console.log(headers)
    setLoadings(true);

    try {
      // const response = await axios.get(`${BASE_URL}/account`, { headers });

      // const CustomOption = (props) => {
      //   const { data, innerRef, innerProps } = props;
      //   return (
      //     <div ref={innerRef} {...innerProps}>
      //       <span style={{ color: 'blue' }}>{data?.gl_code}</span>
      //       {' - '}
      //       <span style={{ color: 'red', fontWeight: 'bold' }}>{data?.gl_name}</span>
      //     </div>
      //   );
      // };

      // const allAccts = response.data?.data;
      // const opt1 = allAccts.map((item) => ({
      //   label: `${item.gl_code} - ${item.gl_name}`,
      //   value: item.id,
      // }));
      // setAllAccounts(opt1);

      const response = await axios.get(`${BASE_URL}/account/banks`, { headers });

      const CustomOption = (props) => {
        const { data, innerRef, innerProps } = props;
        return (
          <div ref={innerRef} {...innerProps}>
            <span style={{ color: 'blue' }}>{data?.gl_code}</span>
            {' - '}
            <span style={{ color: 'red', fontWeight: 'bold' }}>{data?.gl_name}</span>
          </div>
        );
      };

      const results = response.data?.data;
      const opt1 = results.map((item) => ({
        label: item.description,
        value: item.id,
      }));

      setAllAccounts(opt1);




      //   console.log(allAccts, "All Accounts");
    } catch (error) {
      const errorStatus = error.response?.data.message;
      console.error(errorStatus);
    } finally {
      setLoadings(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchAccountss();
    }
  }, [bearer]);


 const handleSelectionChange = (ids) => {
    console.log("Selected IDs:", ids);
    setSelectedIds(ids);
  };



  function formatDates(dateString) {
    const date = new Date(dateString);
    const formattedDate = `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())}`;
    return formattedDate;
  }

  function padZero(num) {
    return num < 10 ? `0${num}` : num;
  }

  const handlePrevPage = () => {
    setCurrentPage(prevPage => Math.max(prevPage - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage(prevPage => Math.min(prevPage + 1, totalPages));
  };

  const formattedTotalEntries = totalEntries.toLocaleString();

  const fetchStat = async () => {
    setStatLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/customer/total-customers`, { headers });
      const stas = response.data?.data;

      setStat(stas);

    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            console.log(errorMessage);
          }
        }
        setStat([]);
      }
    } finally {
      setStatLoading(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchStat();

    }
  }, [bearer]);

  const formatStat = (value) => {
    if (value == null) return "";

    if (value >= 1000 && value < 1000000) {
      const rounded = value / 1000;
      // If divisible by 1000 exactly, no decimals (30k)
      if (value % 1000 === 0) {
        return `${rounded}k`;
      }
      // Else show 2 decimals (30.01k)
      return `${rounded.toFixed(2)}k`;
    }

    if (value >= 1000000) {
      const rounded = value / 1000000;
      if (value % 1000000 === 0) {
        return `${rounded}M`;
      }
      return `${rounded.toFixed(2)}M`;
    }

    // smaller than 1000 → just locale string with commas
    return value.toLocaleString("en-US");
  };

  const isSearching = searchTerm.trim() !== "" && searchedResult.length > 0;
  const handleDateChange1 = (event) => {
    setSelectedEndDate(event.target.value);
  };

  const handleDateChange = (event) => {
    setSelectedDate(event.target.value);
  };

  const handleBank = (selectedOption) => {
    setSelectedBank(selectedOption);
  };

  const handleCreate = () => {

  }

  const fetchContinents = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/continents`, { headers });
      const results = response.data?.data;

      const options = results.map((item) => ({
        label: item.description,
        value: item.id,
      }));
      // setCustomers(results);
      setSelectOptions(options);
    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setCustomers([]);
    } finally {
      setIsLoading(false);
    }
  };


  useEffect(() => {
    if (bearer) {
      fetchContinents();
    }
  }, [bearer]);



  const fetchSubContinents = async () => {
    setLoad(true);
    try {
      const response = await axios.get(`${BASE_URL}/regions`, { headers });

      // console.log(response);
      const subCont = response.data?.data?.regions;
      const options1 = subCont.map((item) => ({
        label: item.description,
        value: item.id,
      }));
      setTableData3(options1);
      // console.log(results);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Redirect to login page if unauthorized
        navigate('/login');
      } else {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            errorMessage = JSON.stringify(error.response.data.message);
          }
        }
        setTableData3([]);
      }
    } finally {
      setLoad(false);
    }
  };

  const fetchSubRegion = async () => {
    setLoad(true);
    try {
      const response = await axios.get(`${BASE_URL}/regions/getprovincesregion?region_id=${selectedRegion}`, { headers });

      // console.log(response);
      const subCont1 = response.data?.data;
      const options2 = subCont1.map((item) => ({
        label: item.description,
        value: item.id,
      }));
      setTableData4(options2);
      console.log(options2);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Redirect to login page if unauthorized
        navigate('/login');
      } else {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            errorMessage = JSON.stringify(error.response.data.message);
          }
        }
        setTableData3([]);
      }
    } finally {
      setLoad(false);
    }
  };
  const fetchProvince = async () => {
    setLoad(true);
    try {
      const response = await axios.get(`${BASE_URL}/provinces`, { headers });

      // console.log(response);
      const subCont15 = response.data?.data.provinces;
      const options25 = subCont15.map((item) => ({
        label: item.description,
        value: item.id,
      }));
      setTableData45(options25);
      console.log(response);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Redirect to login page if unauthorized
        navigate('/login');
      } else {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            errorMessage = JSON.stringify(error.response.data.message);
          }
        }
        setTableData3([]);
      }
    } finally {
      setLoad(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchSubContinents();
    }
  }, [bearer]);

  useEffect(() => {
    if (bearer && selectedRegion) {
      fetchSubRegion(selectedRegion);
    }
  }, [bearer, selectedRegion]);

  useEffect(() => {
    if (bearer) {
      fetchProvince();
    }
  }, [bearer]);

  const handleContinentChange = (selectedOption) => {
    setSelectedContinent(selectedOption.value);
    setSelectedRegion('');
    setSelectedProvince('');
  };


  const handleRegionChange = (selectedOption) => {
    setSelectedRegion(selectedOption.value)
  }

  const handleProvinceChange = (selectedOption) => {
    setSelectedProvince(selectedOption.value)
  }


  function formatDate(dateString) {
    const date = new Date(dateString);
    const formattedDate = `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())} ${padZero(date.getHours())}:${padZero(date.getMinutes())} ${date.getHours() >= 12 ? 'PM' : 'AM'}`;
    return formattedDate;
  }

  function padZero(num) {
    return num < 10 ? `0${num}` : num;
  }

  useEffect(() => {
    if (accounts) {
      const debitTotal = accounts?.reduce((total, item) => total + parseFloat(item.debit), 0);
      const creditTotal = accounts?.reduce((total, item) => total + parseFloat(item.credit), 0);

      // Format the numbers with commas and two decimal places
      const formattedDebitTotal = debitTotal?.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      const formattedCreditTotal = creditTotal?.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });

      setTotalDebit(formattedDebitTotal);
      setTotalCredit(formattedCreditTotal);
    }
  }, [accounts]);

const tableRef = useRef(null);

const handlePrint = () => {
  window.print();
};



  return (
    <div style={{ backgroundColor: "#f9f9f9", minHeight: "100vh" }}>
      <HeaderNav />

      <div className={classes.topContainer}>
         <div className={classes.backTxt}>
          <img src={BackLogo} alt="back" className={classes.iconBtn} onClick={() => navigate(-1)} />
          <div className={classes.bckText}>
            <h3 className={classes.topText}>Bank Position Summary</h3>
            {/* <p className={classes.prgText}>Account Activity Report between the period of {inputss?.start_date
    ? new Date(inputss?.start_date).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      })
    : "--"} to {inputss?.end_date
    ? new Date(inputss?.end_date).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      })
    : "--"}</p> */}
          </div>
          
        </div>
        <div style={{ marginTop: 12 }} />
        <div className={classes.topNavBars}>
          <div className={classes.filterRow}>
            {/* Left side: Inputs */}
            <div className={classes.filterInputs}>
              {/* Account */}
              <div className={classes.inlineField}>
                <label className={classes.inlineLabel}>Account:</label>
                <Multiselect options={allAccounts} onChange={handleSelectionChange}/>
              {/* <Select
  isMulti
  value={selectedOptions}
  onChange={handleChange}
  options={optionsWithAll}
  menuPortalTarget={document.body}
  styles={{
    container: (provided) => ({
      ...provided,
      width: 200,
      fontSize: 12,
    }),
    control: (provided) => ({
      ...provided,
      minHeight: "36px",
      maxHeight: "36px",       // ✅ lock the height
      fontSize: 12,
      overflow: "hidden",
    }),
    valueContainer: (provided) => ({
      ...provided,
      maxHeight: "36px",       // ✅ fix container height
      overflowY: "auto",       // ✅ scroll inside instead of growing
    }),
    multiValue: (provided) => ({
      ...provided,
      fontSize: 12,
    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: 12,
      backgroundColor: state.isFocused ? "#f1f5f9" : "white",
      color: "#111827",
    }),
    menu: (provided) => ({
      ...provided,
      maxHeight: "300px",
      maxWidth: "200px",
      overflowY: "auto",
      fontSize: 12,
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  }}
/> */}


              </div>

              {/* Start Date */}
              <div className={classes.inlineField}>
                <label className={classes.inlineLabel}>Start Date:</label>
                <input
                  className="form-control"
                  type="date"
                  onChange={handleDateChange}
                  value={selectedDate}
                  style={{fontSize: 14}}
                  min={minDate}
                  max={maxDate}
                  required
                />
              </div>

              {/* End Date */}
              <div className={classes.inlineField}>
                <label className={classes.inlineLabel}>End Date:</label>
                <input
                  className="form-control"
                  type="date"
                  onChange={handleDateChange1}
                  value={selectedEndDate}
                  min={minDate}
                  max={maxDate}
                   style={{fontSize: 14}}
                  required
                />
              </div>
              <button className={classes.loanBtn} onClick={fetchReports}> <img src={run} alt="run-report" /> Run Report </button>
            </div>

            {/* Right side: 3 icons */}
            
          </div>


        </div>
        <div style={{ marginTop: 24 }} />
       
        <div  className={classes.tableContainer}>
         {accounts.length === 0 ? (
             <div
               style={{
                 textAlign: "center",
                 padding: "40px",
                 fontSize: "18px",
                 color: "#374151",
               }}
             >
               <p>No data to display</p>
             </div>
           ) : (
             <>
               <div className={classes.sideTools}>
                 {accounts.length > 0 && (
                   <div className={classes.filterIcons}>
                     <img
                       src={MailLogo}
                       alt="icon1"
                       className={classes.iconBtns}
                       onClick={() => console.log("icon1")}
                     />
                     <img
                       onClick={() => handlePrint()}
                       src={PrintLogo}
                       alt="icon2"
                       className={classes.iconBtns}
                     />
                     <img
                       src={DownloadLogo}
                       alt="icon3"
                       className={classes.iconBtns}
                       onClick={() => console.log("icon3")}
                     />
                   </div>
                 )}
               </div>
          <div className={classes.cntrTable}>
            <h1 className={classes.cntrTxt}>The Redeemed Christian Church Of God</h1>
             <p className={classes.cntrTxt12}>{province === 'undefined' ? admin : province}</p>
              <p className={classes.cntrTx122} style={{marginBottom: "40px"}} >Bank Position Summary Report
                       between the period of {" "} {selectedDate
                         ? new Date(selectedDate).toLocaleDateString("en-US", {
                             year: "numeric",
                             month: "long",
                             day: "numeric",
                           })
                         : "--"} to {" "}
                       {selectedEndDate
                         ? new Date(selectedEndDate).toLocaleDateString("en-US", {
                             year: "numeric",
                             month: "long",
                             day: "numeric",
                           })
                         : "--"}
                     </p>
           

          </div>
 <table style={{ width: "80%", borderCollapse: "collapse", margin: 'auto' }}>
          <thead>
           
         
            <tr style={{borderBottom: "1px solid #d1d5db",}}>
      <th style={{ textAlign: 'left', fontSize: 14}}>Bank Name</th>
      <th style={{ textAlign: 'right',  fontSize: 14 }}>Amount</th>
    </tr>
          </thead>
          <tbody>
            
            {Object.keys(groupedData).map((gl_code) => {
    const group = groupedData[gl_code];
    const totals = calculateTotals(group);
    return (
      <React.Fragment key={gl_code}>
        {group.map((item, index) => (
          <tr  style={{borderBottom: "1px solid #d1d5db",}} key={index}>
            <td style={{ fontSize: 14,}}>{item.name || ''}</td>
            {/* <td>{item.account?.amount || ''}</td> */}
            <td style={{ textAlign: "right", fontSize: 14 }}>
              {(parseFloat(item.amount) || 0).toLocaleString('en-US', {
                minimumIntegerDigits: 1,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })}
            </td>
          </tr>
        ))}
    
      </React.Fragment>
    );
  })}
          </tbody>
        </table>
         
        

         


 </>
  )}
        </div>
     <div style={{ marginTop: 27 }} />
 
      </div>
      {savingsLoading && (
        <div className={classes.overlay}>
          <img src={RotatingLogo} alt="Loading..." className={classes.spinnerLogo} />
        </div>
      )}

    </div>
  )
}

export default BankSummary
